<template>
  <div>
    <div class="bullet-point" v-html="movementBulletPoints(models, 'gopWinProbability')"></div>
    <div v-for="(item, index) in signedBulletPoints" :key="index" class="bullet-point">
      <Tweet
        v-if="hasTweetId(item)"
        :id="hasTweetId(item)"
        :options="{ theme: isDarkMode ? 'dark' : 'light' }"
        :key="isDarkMode">
      </Tweet>
      <template v-else>
        <div v-html="item.text"></div>
        <div v-if="item.signature || item.twitterHandle" class="note-signature">
          <span v-if="item.signature">{{ item.signature }}</span>
          <span v-if="item.twitterHandle"> | </span>
          <a v-if="item.twitterHandle" :href="`https://twitter.com/${item.twitterHandle.substr(1)}`" target="_blank">
            {{ item.twitterHandle }}
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {Tweet} from 'vue-tweet-embed'

import { mapGetters } from 'vuex'

const props = {
  chamber: {
    type: String,
    required: false
  },
  currentModel: {
    type: Object,
    required: true
  },
  models: {
    type: Array,
    required: true
  },
  currentDate: {
    type: String,
    required: true
  }
}

const components = {
  Tweet
}

const computed = {
  ...mapGetters({
    dates: 'aggregateModels/dates',
    isDarkMode: 'persistentUx/isDarkMode'
  }),
  signedBulletPoints () {
    return this.currentModel.signedBulletPoints
  }
}

const methods = {
  hasTweetId (item) {
    if (item.text.includes('twitter.com') && item.text.includes('status')) {
      let snippet = document.createElement('div')
      snippet.innerHTML = item.text
      const links = snippet.getElementsByTagName('a')
      const url = links[links.length - 1].href
      const parts = url.split('/')
      return parts[parts.length - 1]
    }
    return false
  },
  movementBulletPoints (models, key) {
    let text
    const index = this.dates.indexOf(this.currentDate)
    const current = models.find(model => model.date === this.currentDate)
    const prev = models.find(model => model.date === this.dates[index - 7])
    if (prev && index > 0) {
      let diff = Math.round((current[key] - prev[key]) * 10000) / 100
      diff = diff.toString()
      let party = null
      if (diff.includes('-')) {
        party = this.chamber === 'president' ? 'Joe Biden' : 'the Democrats'
        diff = diff.replace('-', '')
      } else {
        party = this.chamber === 'president' ? 'Donald Trump' : 'the Republicans'
      }
      text =`Moved ${diff}% towards ${party} in this race over the last week.`
    }
    return text
  }
}
export default {
  props,
  components,
  computed,
  methods
}
</script>

<style>
.note-signature {
  text-align: start;
  opacity: 0.7;
}
</style>
